import React, { useEffect, useRef } from 'react';

import { Toast, ToastMessage } from 'primereact/toast';
import { useDispatch, useSelector } from 'react-redux';

import { removeToast, ToastType } from '@/app/slices/toast';

export const ToastContainer: React.FC = () => {
  const toast = useRef<Toast>(null);
  const dispatch = useDispatch();
  const { messages } = useSelector(
    (state: { toast: ToastType }) => state.toast,
  );

  useEffect(() => {
    if (messages.length > 0 && toast.current) {
      toast.current.show(messages[messages.length - 1] as ToastMessage);
      dispatch(removeToast(messages.length - 1));
    }
  }, [messages, dispatch]);

  return <Toast ref={toast} />;
};
